import React, {useState, useEffect, useContext} from "react";
import {registerLocale} from "react-datepicker";
import * as Yup from "yup";
import {it} from "date-fns/locale";
import {TranslateContext} from "../../../context/TranslateContext";
import {
    aggiornaMacrocategoriaApi, aggiungiMacrocategoriaApi,
    getClassiMacrocategorieApi, getMacrocategoriePadriApi
} from "../services/MacrocategorieServices";
import FormModificaMacrocategoriaView from "./FormModificaMacrocategoriaView";

registerLocale('it', it)

export default function FormModificaMacrocategoriaController({
                                                                 id,
                                                                 idClasse,
                                                                 formikRef,
                                                                 history,
                                                                 principale,
                                                                 elemento = null,
                                                                 padre = null,
                                                                 addFiglio = false
                                                             }) {

    const [macr, setMacr] = useState(elemento);
    const [optionsClassi, setOptionsClassi] = useState([]);
    const [optionsPadri, setOptionsPadri] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [nuovoPadre, setNuovoPadre] = useState(padre);

    const {translate} = useContext(TranslateContext);

    const getPadri = async (idClasse) => {
        if (idClasse) {
            const response = await getMacrocategoriePadriApi(idClasse);
            let val = response.data.data;
            if (val) {
                setOptionsPadri(val);
            }
        }
    }

    async function getClassi() {
        let params = ''

        if (!id || addFiglio === true) {
            // non ho id: l'oggetto è nuovo, devo restituire le classi root o le classi compatibili con il padre
            if (principale === true) {
                params = '?idClMadre=' + (idClasse || '');
            }
        } else if (elemento) {
            // ho id: sono in update, aspetto di avere l'oggetto e recupero le classi compatibili con padre e figli
            let idObjPadre = (nuovoPadre && nuovoPadre.id_kpi_macrocategoria_madre) || elemento.id_kpi_macrocategoria_madre;
            params = elemento.id_kpi_macrocategoria_madre ? '?idMc=' + id + '&idMcMadre=' + idObjPadre : '';
        }

        const response = await getClassiMacrocategorieApi(params);
        setOptionsClassi(response.data.data);
    }

    useEffect(() => {
        setMacr(elemento)

        if (id && elemento && elemento.id_classe_macrocategoria) {
            getPadri(elemento.id_classe_macrocategoria)
        }

        // se cambio oggetto padre devo eseguire nuovamente la chiamata visto che potrebbero essere cambiate le classi compatibili
        getClassi();
    }, [id, elemento, idClasse, principale, nuovoPadre]);

    const closeModal = () => setShow(false);

    var SignupSchema = Yup.object().shape({
        id_classe_macrocategoria: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        codice: Yup.string()
            .max(20, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(500, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio'))
    });

    async function aggiornaMacrocategoria(newObj) {
        const response = await aggiornaMacrocategoriaApi(id, newObj);
        if (response.data.result === 0) {
            history.goBack()
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiMacrocategoria(newObj) {
        const response = await aggiungiMacrocategoriaApi(newObj);
        if (response.data.result === 0) {
            history.goBack()
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    function handleCloseConfirmModifica() {
        setShowConfirm(false)
    }

    function handleOkConfirmModifica() {
        formikRef.current.setFieldValue('id_kpi_macrocategoria_madre', (nuovoPadre && nuovoPadre.id_kpi_macrocategoria))
        setShowConfirm(false)
    }

    const initialValuesForm = {
        id_kpi_macrocategoria: '',
        id_classe_macrocategoria: '',
        classe_kpi: '',
        codice: '',
        descrizione: '',
        ordine: '',
        canc: '0',
        id_kpi_macrocategoria_madre: ''
    };

    function onSubmitForm(values) {
        let newObj = values;

        if (id && !idClasse) {
            aggiornaMacrocategoria(newObj);
        } else {
            if (idClasse) {
                newObj['id_kpi_macrocategoria_madre'] = id;
            }

            aggiungiMacrocategoria(newObj);
        }
    }

    function onChangeMacrocategoria(obj) {
        if (obj) {
            if (principale !== true) {
                getPadri(obj.code)
            }
        }
    }

    function onChangeMacrocategoriaMadre(obj) {
        if (id) {
            // Chiedo conferma prima di modificare il padre
            setShowConfirm(true);
        }

        let padriFiltrati = optionsPadri.filter((p) => p.id == obj.code);
        if (padriFiltrati && padriFiltrati.length > 0) {
            setNuovoPadre(padriFiltrati.reduce((p) => p));
        } else {
            setNuovoPadre(null);
        }
    }

    return (
        <FormModificaMacrocategoriaView
            show={show}
            translate={translate}
            id={id}
            closeModal={closeModal}
            principale={principale}
            formikRef={formikRef}
            optionsClassi={optionsClassi}
            SignupSchema={SignupSchema}
            showConfirm={showConfirm}
            modalMsg={modalMsg}
            addFiglio={addFiglio}
            macr={macr}
            optionsPadri={optionsPadri}
            handleCloseConfirmModifica={handleCloseConfirmModifica}
            handleOkConfirmModifica={handleOkConfirmModifica}
            initialValuesForm={initialValuesForm}
            onSubmitForm={onSubmitForm}
            onChangeMacrocategoria={onChangeMacrocategoria}
            onChangeMacrocategoriaMadre={onChangeMacrocategoriaMadre}
        />
    );
}